export const typeInvoice = [
  { id: "invoice", name: "Adhoc/Invoice" },
  { id: "credit_note", name: "Credit Note" },
];

export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export enum IncludeStudentOptionEnum {
  StudentOnly = "studentOnly",
  StudentWithSchedulePeriod = "studentWithSchedulePeriod",
}

export const includeStudentOptionList = [
  { id: IncludeStudentOptionEnum.StudentOnly, name: "Student Only" },
  { id: IncludeStudentOptionEnum.StudentWithSchedulePeriod, name: "Student With Schedule Period" },
];

export const isTaggedCreditNoteList = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];
